<template>
  <div class="wrapper" :class="[{ 'nav-open': $sidebar.showSidebar }]">
    <notifications></notifications>
    <side-bar
      :active-color="sidebarBackground"
      :background-image="sidebarBackgroundImage"
      :data-background-color="sidebarBackgroundColor"
    >
      <mobile-menu></mobile-menu>
      <template slot="links">
        <sidebar-item
          :link="{ name: 'Dashboard', icon: 'bar_chart', path: '/dashboard' }"
        ></sidebar-item>
        <sidebar-item
          :link="{
            name: 'Portfolio',
            icon: plantIcon,
            path: '/portfolio/clients'
          }"
        ></sidebar-item>
        <sidebar-item
          :link="{
            name: 'Statutory Inspections',
            icon: statInspIcon,
            path: '/stat-insp/stat-insp-list'
          }"
        >
          <sidebar-item
            :link="{
              name: 'Plant without Stat. Insp.',
              path: '/stat-insp/plants-without-stat-insps'
            }"
          ></sidebar-item>
          <sidebar-item
            :link="{
              name: 'View Stat. Insp.',
              path: '/stat-insp/stat-insp-list'
            }"
          ></sidebar-item>
        </sidebar-item>

        <sidebar-item
          :link="{
            name: 'Quotes',
            icon: quoteIcon,
            path: '/'
          }"
        >
          <sidebar-item
            :link="{
              name: 'Live',
              path: '/quotes/live'
            }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: 'Completed', path: '/quotes/completed' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: 'Rejected', path: '/quotes/rejected' }"
          ></sidebar-item>
        </sidebar-item>
      </template>
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>

      <div
        :class="{ content: !$route.meta.hideContent }"
        @click="toggleSidebar"
      >
        <alert />
        <zoom-center-transition :duration="200" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </zoom-center-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
    document.getElementsByClassName(className)[0].scrollTop = 0;
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

function reinitScrollbar() {
  let docClasses = document.body.classList;
  let isWindows = navigator.platform.startsWith("Win");
  if (isWindows) {
    // if we are on windows OS we activate the perfectScrollbar function
    initScrollbar("sidebar");
    initScrollbar("sidebar-wrapper");
    initScrollbar("main-panel");

    docClasses.add("perfect-scrollbar-on");
  } else {
    docClasses.add("perfect-scrollbar-off");
  }
}

import TopNavbar from "./TopNavbar.vue";
import Alert from "./Alert.vue";
import ContentFooter from "./ContentFooter.vue";
import MobileMenu from "./Extra/MobileMenu.vue";
import { ZoomCenterTransition } from "vue2-transitions";
import { mapGetters } from "vuex";

export default {
  components: {
    Alert,
    TopNavbar,
    ContentFooter,
    MobileMenu,
    ZoomCenterTransition
  },
  data() {
    return {
      sidebarBackgroundColor: "black",
      sidebarBackground: "",
      sidebarBackgroundImage: "",
      sidebarMini: true,
      sidebarImg: false
    };
  },
  computed: {
    ...mapGetters({
      statInspIcon: "stat-insp/icon",
      quoteIcon: "quote/icon",
      plantIcon: "portfolio/icon"
    })
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(true);
      }
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    }
  },
  updated() {
    reinitScrollbar();
  },
  mounted() {
    reinitScrollbar();
  },
  watch: {
    sidebarMini() {
      this.minimizeSidebar();
    }
  }
};
</script>
<style lang="scss">
$scaleSize: 0.95;
@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  to {
    opacity: 1;
  }
}
.main-panel .zoomIn {
  animation-name: zoomIn95;
}
@keyframes zoomOut95 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}
.main-panel .zoomOut {
  animation-name: zoomOut95;
}
</style>
